import { EngineMode } from '@services/engine/types'
import { useSceneState } from './useScene'

export const useVectorOrPixelMode = () => {
  const mode = useSceneState('mode')
  return mode === EngineMode.OUTLINE || mode === EngineMode.PIXEL
}
